import BasePriceBinder from './BasePriceBinder';

export default class SelectBinder extends BasePriceBinder {
	optionValue;
	optionLabel;

	constructor(
		id,
		title,
		calculator,
		summaryDisplayer,
		priceFormatter,
		optionLabel,
		optionValue
	) {
		super(
			id,
			`${title} (${optionLabel})`,
			calculator,
			summaryDisplayer,
			priceFormatter
		);
		this.optionLabel = optionLabel;
		this.optionValue = optionValue;
		this.optionId = `${this.id}_${optionValue}`;
		this.baseElement = document.getElementById(this.id);
		this.isActive = this.baseElement.value === this.optionValue;
		this.isEnabled = true;
	}

	initEvents() {
		this.baseElement.addEventListener('change', (e) => {
			this.isActive = e.target.value === this.optionValue;
			this.handleChange();
		});

		super.initEvents();
	}

	updateFieldPrice() {
		this.baseElement.querySelector(
			`option[value="${this.optionValue}"]`
		).text =
			`${this.optionLabel} (${this.priceFormatter.format(this.currentPrice)})`;
	}
}
